'use client';

import { type Component, type ComponentProps } from '../../types/component';
import { CoreIcon } from '../core-icon/CoreIcon';
import {
  ChipBase,
  type ChipBaseWithAvatar,
  type ChipBaseWithIcon,
} from './internal/ChipBase';

type ActionChipBaseProps = ChipBaseWithIcon | ChipBaseWithAvatar;

type ActionChipProps = ComponentProps<
  ActionChipBaseProps,
  'button',
  'disabled'
>;

type ActionChipComponent = Component<ActionChipBaseProps, 'button', 'disabled'>;

const ActionChip: ActionChipComponent = (props) => {
  const {
    children,
    icon,
    avatar,
    size,
    isDisabled,
    isFullWidth,
    elevation,
    isSelected,
    ...rest
  } = props;

  const leadingProps =
    icon != null ? { icon } : avatar != null ? { avatar } : {};

  return (
    <ChipBase
      {...rest}
      {...leadingProps}
      size={size}
      isDisabled={isDisabled}
      isFullWidth={isFullWidth}
      elevation={elevation}
      isSelected={isSelected}
      trailing={<CoreIcon name="chevronupdown" size="xs" />}
    >
      {children}
    </ChipBase>
  );
};

ActionChip.displayName = 'ActionChip';

export { ActionChip, type ActionChipProps, type ActionChipBaseProps };
